import React, { Suspense, useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Route, Redirect } from "react-router-dom";
import { ILoggedUser } from "src/models/Authentication/Authentication.models";
import { RootState } from "src/store/reducers";
import { setAuthUser } from "src/services/Authentication/AuthenticationService";
import { LOGIN_PAGE, NotAuthRoutes } from "src/constants/pagesRoutes";
import { INIT, UNATHORIZED } from "../../constants/pagesRoutes";
import { canAccessSpecialAccessRoute, isSpecialAccessRoute } from "src/services/Authentication/AccessService";
import { getSpecialAccessUsernames, getSpecialAccessLoaded } from "src/store/Authentication/authSelectors";
import SyncLoader from "react-spinners/SyncLoader";
import UserOnboarding from 'react-user-onboarding'
import { RefsContext } from "src/contexts/OnboardingContext";
import bg from "../../assets/images/onboarding_bg.png";
import { ShowUserOnboard, UpdateUserOnboard } from "src/services/Maintenance/UserService";

interface AuthLayoutProps {
  component: any;
  layout: any;
  isAuthProtected: any;
  path?: string;
  exact?: boolean;
  key?: number;
}

const Authmiddleware = ({
  component,
  layout,
  isAuthProtected,
  path,
  exact,
  key,
  ...rest
}: AuthLayoutProps) => {
  const Layout = layout;
  const Component = component;
  const auth: ILoggedUser = useSelector((state: RootState) => state.auth);
  const allowedUsernames = useSelector(getSpecialAccessUsernames);
  const specialAccessLoaded = useSelector(getSpecialAccessLoaded);
  const refsContext = useContext(RefsContext);
  
  const { tooltip1,tooltip2,tooltip3, showOnboard, setShowOnboard } = refsContext;
  const story = [
    // {
    //   component: 'modal',
    //   intro: true,
    //   className: 'dshclass',
    //   // className: 'mainsidebarcontent',
    //   children: (<div>modal content goes here</div>)
    // },
    {
      intro: true,
      component: 'modal',
      children: (<div>
        <p style={{
          fontSize: "13px",
          fontWeight: 600,
          marginBottom: 1,
          textAlign: "center"     
        }}>¡Bienvenido a Dual Cloud!</p>
        <p>
          <img src={bg} alt="background lanyard" className="img-fluid exclude-from-style" />
        </p>
        <p style={{
          fontSize: "12px",
          fontWeight: 400,
          marginBottom: 1,
          textAlign: "justify"       
        }}>Estamos aquí para guiarte en tu primer recorrido por el sistema ERP. En solo unos minutos, estarás listo para comenzar a gestionar tu negocio de manera eficiente.</p>
      </div>)
    },
    {
      intro: false,
      ref: tooltip1,
      component: 'tooltip',
      children: (<div>
        <p style={{
          fontSize: "13px",
          fontWeight: 600,
          marginBottom: 1    ,
          color:"#868686"      
        }}>Paso 1/3</p>
        <p style={{
          fontSize: "13px",
          fontWeight: 600,
          marginBottom: 1          
        }}>Dashboard</p>
        <p style={{
          fontSize: "12px",
          fontWeight: 400,
          marginBottom: 16,
          textAlign: "justify"       
        }}>Aquí  encontrarás un resumen de los datos clave de tu negocio, como ventas e inventario. Todo está organizado para darte una visión rápida y clara.</p>
      </div>)
    },
    {
      component: 'speech-bubble',
      ref: tooltip2,
      children: (<div>
        <p style={{
          fontSize: "13px",
          fontWeight: 600,
          marginBottom: 1    ,
          color:"#868686"      
        }}>Paso 2/3</p>
        <p style={{
          fontSize: "13px",
          fontWeight: 600,
          marginBottom: 1          
        }}>Menú Principal</p>
        <p style={{
          fontSize: "12px",
          fontWeight: 400,
          marginBottom: 20,
          textAlign: "justify"       
        }}>En el menú lateral izquierdo, tienes acceso a todas las secciones del ERP: productos, clientes, reportes, y más. Es tu centro de control.</p>
      </div>)
    },
    {
      component: 'tooltip',
      // intro: false,
      ref: tooltip3,
      horizontalPosition: 'left',
      children: (<div>
        <p style={{
          fontSize: "13px",
          fontWeight: 600,
          marginBottom: 1    ,
          color:"#868686"      
        }}>Paso 3/3</p>
        <p style={{
          fontSize: "13px",
          fontWeight: 600,
          marginBottom: 16         
        }}>Acceso rápido</p>
        <p style={{
          fontSize: "12px",
          fontWeight: 400,
          marginBottom: 1,
          textAlign: "justify"       
        }}>Utiliza el botón <span style={{fontWeight: 600}}>'+ Crear'</span> para añadir nuevos productos, clientes o ventas de forma rápida. Y si necesitas más ayuda, siempre puedes encontrar más información en la sección de soporte.</p>
      </div>)
    }
  ];
  useEffect(() => {
    if (tooltip1 && tooltip2 && tooltip3) {
      // Perform operations that require these refs
    }
  }, [tooltip1, tooltip2, tooltip3]);
  useEffect(() => {
    if (!auth.user) return;
    setAuthUser(auth);
  }, [auth]);

  const isPathValid = (): boolean => {
    if (NotAuthRoutes.includes(path || "/")) return true;
    const existPath = auth.user?.pagesAccess.find(pag => pag.pageURL === path);

    return existPath ? true : false;
  };

  async function handleClose() {
    //Indicar que el usuario ya abrio el onboarding
    setShowOnboard(false)
    await UpdateUserOnboard()
  }

  return (
    <Route
      {...rest}
      render={props => {
        if (isAuthProtected && !auth.logged) {
          return (
            <Redirect
              to={{ pathname: LOGIN_PAGE, state: { from: props.location } }}
            />
          );
        }

        if (!isAuthProtected && auth.logged) {
          return (
            <Redirect
              to={{ pathname: INIT, state: { from: props.location } }}
            />
          );
        }

        if (!isPathValid()) {
          return (
            <Redirect
              to={{ pathname: UNATHORIZED, state: { from: props.location } }}
            />
          );
        }

        if (
          isSpecialAccessRoute(path || "") &&
          !specialAccessLoaded
        ) {
          return (
            <div className="pt-5 d-flex justify-content-center">
              <SyncLoader size={20} margin={10} color={"#5156be"} />
            </div>
          );
        }

        if (!canAccessSpecialAccessRoute(path || "", auth.user?.username, allowedUsernames)) {
          return (
            <Redirect
              to={{ pathname: UNATHORIZED, state: { from: props.location } }}
            />
          );
        }

        return (
          <Layout>
            <Suspense
              fallback={
                <div className="pt-5 d-flex justify-content-center">
                  <SyncLoader size={20} margin={10} color={"#5156be"} />
                </div>
              }
            >
            <UserOnboarding 
                story={story} 
                isVisible={showOnboard}
                onClose={() => handleClose()} 
              />
              <Component {...props} />
            </Suspense>
          </Layout>
        );
      }}
    />
  );
};

export default Authmiddleware;
